export const universities = [
    {
        id: 'mgtu',
        name: 'МГТУ',
    },
    {
        id: 'mgu',
        name: 'МГУ',
    },
    {
        id: 'misis',
        name: 'МИСиС'
    },
    {
        id: 'mfti',
        name: 'МФТИ'
    },
    {
        id: 'ngu',
        name: 'НГУ Новосибирск',
    },
    {
        id: 'hse',
        name: 'НИУ ВШЭ'
    },
    {
        id: 'spbgu',
        name: 'СПбГУ'
    },
    {
        id: 'other',
        name: 'Другое'
    }
]

export const faculties = [
    {
        id: 'fac-mgtu',
        university: 'mgtu',
        name: 'Информатика, искусственный интеллект и системы управления (ИУ)',
    },
    {
        id: 'fac-mgtu2',
        university: 'mgtu',
        name: 'Инженерный бизнес и менеджмент',
    },
    {
        id: 'fac-mgtu3',
        university: 'mgtu',
        name: 'Фундаментальные науки',
    },
    {
        id: 'fac-mgu1',
        university: 'mgu',
        name: 'Механико-математический факультет',
    },
    {
        id: 'fac-misis',
        university: 'misis',
        name: 'Институт экономики и управления'
    },
    {
        id: 'fac-mfti',
        university: 'mfti',
        name: 'Физтех-школа прикладной математики и информатики'
    },
    {
        id: 'fac-ngu',
        university: 'ngu',
        name: 'Факультет информационных технологий',
    },
    {
        id: 'fac-ngu-2',
        university: 'ngu',
        name: 'Механико-математический факультет',
    },
    {
        id: 'fac-hse',
        university: 'hse',
        name: 'Факультет компьютерных наук'
    },
    {
        id: 'fac-spbgu',
        university: 'spbgu',
        name: 'Факультет прикладной математики — процессов управления'
    },
    {
        id: 'fac-spbgu-1',
        university: 'spbgu',
        name: 'Экономический факультет'
    },
    {
        id: 'fac-other',
        university: 'all',
        name: 'Другое'
    }
]